/**
 *
 * Asynchronously loads the component for CustomerSettings
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CustomerSettings = lazyLoad(
  () => import('./index'),
  module => module.CustomerSettings,
);
